import styled, { css } from 'styled-components';

import {
  StyledSizeProps,
  StyledSpacingProps,
  StyledTextProps,
  textStyles,
} from '../../styles';

const getSingleLineTruncateStyles = () => css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const getMultiLineTruncateStyles = (numberOfLines: number) => css`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${numberOfLines};
  -webkit-box-orient: vertical;
`;

type Props = StyledSizeProps &
  StyledSpacingProps &
  StyledTextProps & {
    $numberOfLines: number;
  };

export const TypographyRoot = styled.span<Props>(
  ({ $numberOfLines }) => css`
    ${$numberOfLines > 1
      ? getMultiLineTruncateStyles($numberOfLines)
      : getSingleLineTruncateStyles()}

    ${textStyles}
  `,
);
